import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: блок «ПИК в цифрах» попал в зону видимости.
 */
export function trackShowPikInNumbersSection(): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'pik_in_numbers',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
